// two things must be added to an element for it to be a trigger for opening the comments modal:
// - supply-issues-comments class
// - a data-supply_issue_id attribute with the supply issue id to pull comments for (or via the dataset: data('supply_issue_id', 111)).

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.supply_issues = abcsetup.rfq.supply_issues || {};
abcsetup.rfq.supply_issues.comments = abcsetup.rfq.supply_issues.comments || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.supply_issues.comments = {
    init() {
        const _this = this;

        $(document).on('click', '.supply-issues-comments', function (event) {
            event.preventDefault();

            _this.displayCommentsModal($(this).data('supply_issue_id'));
        });
    },

    /**
     * Open a modal with the comments for the given supply issue in it.
     */
    displayCommentsModal: function (supplyIssueId) {
        abcsetup.blockUI(true);

        axios.get(`/api/rfq/supply_issues/comments/${supplyIssueId}`).then(response => {
            abcsetup.unblockUI();
            this._removeExistingModal();
            this._mountAndOpenModal(response.data, supplyIssueId);
        });
    },

    /**
     * Remove any existing comments modal.
     * @private
     */
    _removeExistingModal() {
        const Modal = $('#rfq-supply-issue-comments-modal');
        Modal.next('.modal-backdrop').remove();
        Modal.remove();
    },

    /**
     * Add the given modal HTML to the DOM, open the modal and setup any JS bindings needed for it.
     *
     * @param modalHtml
     * @param supplyIssueId
     * @private
     */
    _mountAndOpenModal(modalHtml, supplyIssueId) {
        $('body').append(modalHtml);
        const Modal = $('#rfq-supply-issue-comments-modal');

        Modal.modal('show');
        Modal.find('.add-comment .btn-primary').on('click', () => {
            abcsetup.blockUI(true);
            axios.post(`/api/rfq/supply_issues/comments/${supplyIssueId}`, {
                body: Modal.find('[name=new_comment]').val(),
            }).then(() => {
                this.displayCommentsModal(supplyIssueId, true);
            });
        });
    },
}
